export default __webpack_public_path__ + "static/media/padi_lggutappa.188d2c3e.jpg";